import { useEffect, useState } from "react";
export const useClarity = (consentCookieName = "clarity_consent", forceRenderInitial = false) => {
    const [forceRender, setForceRender] = useState(forceRenderInitial);
    // Lecture du cookie
    const getCookie = (name) => {
        return document.cookie
            .split("; ")
            .find((row) => row.startsWith(`${name}=`))
            ?.split("=")[1];
    };
    // Définit un cookie
    const setCookie = (name, value, days = 365) => {
        const maxAge = days * 24 * 60 * 60;
        document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; SameSite=Lax; Secure`;
        setForceRender((prev) => true);
    };
    // Charger Clarity
    const loadClarity = () => {
        (function (c, l, a, r, i, t, y) {
            c[a] =
                c[a] ||
                    function () {
                        (c[a].q = c[a].q || []).push(arguments);
                    };
            t = l.createElement(r);
            t.async = 1;
            t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script");
    };
    useEffect(() => {
        if (typeof window === "undefined" || !forceRender)
            return;
        if (getCookie(consentCookieName) === "true") {
            loadClarity();
        }
    }, [forceRender]);
    return { setCookie, getCookie, loadClarity };
};
